import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]

  submit(event) {
    // Prevent submission if empty
    const content = this.inputTarget.value.trim()
    if (!content) {
      event.preventDefault()
      return
    }

    // Disable submit button
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.style.opacity = '0.6'
    }
  }

  clear(event) {
    // Clear the input after successful submission
    if (event.detail.success !== false) {
      if (this.hasInputTarget) {
        this.inputTarget.value = ""
        this.inputTarget.style.height = '44px'
      }
    }

    // Re-enable submit button
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
      this.submitTarget.style.opacity = '1'
    }
  }

  adjustHeight(event) {
    const input = event.target
    input.style.height = '44px'
    input.style.height = `${Math.min(input.scrollHeight, 120)}px`
  }
}

